<div class="pos-wrapper" data-testid="pos-wrapper">
  <div class="sidebar" data-testid="sidebar">
    <div class="bar-header" data-testid="bar-header">
      <img routerLink="/production/home/departments" src="assets/admin-nav/newbrijjLogo.svg"
        style="height: 3.8rem; width: 6rem" data-testid="sidebar-logo" />
      <span data-testid="sidebar-logo-spacer"></span>
    </div>
    <div class="top-menu" data-testid="top-menu">
      <div class="menu" data-testid="menu">
        <ul class="ps-0" data-testid="menu-list">
          <!-- Item Entry Section -->
          <li [ngClass]="{ active: isMenuItemActive[0] }" data-testid="menu-item-entry">
            <a (click)="getDataForMenu(0)" class="first-a" routerLink="/production/home/departments"
              data-testid="menu-item-entry-link">
              <img src="../../../../assets/Pos_sidebar/list_alt.svg" data-testid="menu-item-entry-icon" />
              <span class="li-descr" data-testid="menu-item-entry-label">Item Entry</span>
            </a>
            <a class="arrow" data-testid="menu-item-entry-arrow">
              <span></span>
            </a>
          </li>
          <!-- Dashboard -->
          <ng-template [ngxPermissionsOnly]="['Report:ViewPSProductionOverview']">
            <li [ngClass]="{ active: isMenuItemActive[1] }" data-testid="menu-dashboard">
              <a (click)="getDataForMenu(1)" class="first-a" [routerLink]="productionOverviewRoute"
                data-testid="menu-dashboard-link">
                <img src="../../../../assets/Pos_sidebar/dashboard.svg" data-testid="menu-dashboard-icon" />
                <span class="li-descr" data-testid="menu-dashboard-label">Dashboard</span>
              </a>
              <a class="arrow" data-testid="menu-dashboard-arrow">
                <span></span>
              </a>
            </li>
          </ng-template>
          <!-- Top Performer -->
          <ng-template [ngxPermissionsOnly]="['Report:ViewPSTopPerformer']">
            <li [ngClass]="{ active: isMenuItemActive[2] }" data-testid="menu-top-performer">
              <a (click)="getDataForMenu(2)" class="first-a" [routerLink]="topPerformerRoute"
                data-testid="menu-top-performer-link">
                <img src="../../../../assets/Pos_sidebar/Icon_top-performers.svg"
                  data-testid="menu-top-performer-icon" />
                <span class="li-descr" data-testid="menu-top-performer-label">Top Performer</span>
              </a>
              <a class="arrow" data-testid="menu-top-performer-arrow">
                <span></span>
              </a>
            </li>
          </ng-template>
          <!-- Move to  Floor  -->
          <!-- <ng-template [ngxPermissionsOnly]="['Item:MoveToFloor']">
            <li [ngClass]="{ active: isMenuItemActive[3] }" data-testid="menu-move-to-floor">
              <a
                (click)="getDataForMenu(3)"
                class="first-a"
                routerLink="/production/home/move-floor"
                data-testid="menu-move-to-floor-link"
              >
                <img src="../../../../assets/Pos_sidebar/icon_move2floor.svg" data-testid="menu-move-to-floor-icon" />
                <span class="li-descr" data-testid="menu-move-to-floor-label">Move to Floor</span>
              </a>
              <a class="arrow" data-testid="menu-move-to-floor-arrow">
                <span></span>
              </a>
            </li>
          </ng-template> -->
          <!-- History -->
          <ng-template [ngxPermissionsOnly]="['History:View']">
            <li [ngClass]="{ active: isMenuItemActive[4] }" data-testid="menu-history">
              <a (click)="getDataForMenu(4)" class="first-a" routerLink="/production/home/history"
                data-testid="menu-history-link">
                <img src="../../../../assets/Pos_sidebar/icon_history.svg" data-testid="menu-history-icon" />
                <span class="li-descr" data-testid="menu-history-label">History</span>
              </a>
              <a class="arrow" data-testid="menu-history-arrow">
                <span></span>
              </a>
            </li>
          </ng-template>
          <!-- New Item Entry -->
          <ng-template [ngxPermissionsOnly]="['Item:BulkEntry']">
            <li [ngClass]="{ active: isMenuItemActive[5] }" data-testid="menu-bulk-item-entry">
              <a (click)="getDataForMenu(5)" class="first-a" routerLink="/production/home/new-entry"
                data-testid="menu-bulk-item-entry-link">
                <img src="../../../../assets/Pos_sidebar/Icon_new-items-entry.svg"
                  data-testid="menu-bulk-item-entry-icon" />
                <span class="li-descr" data-testid="menu-bulk-item-entry-label">Bulk Item Entry</span>
              </a>
              <a class="arrow" data-testid="menu-bulk-item-entry-arrow">
                <span></span>
              </a>
            </li>
          </ng-template>
          <!--SCANPULLS-->
          <ng-template [ngxPermissionsOnly]="['Item:ScanPull']">
            <li [ngClass]="{ active: isMenuItemActive[6] }" data-testid="menu-scan-pulls">
              <a (click)="getDataForMenu(6)" class="first-a" routerLink="/production/home/scan-pulls"
                data-testid="menu-scan-pulls-link">
                <img src="../../../../assets/Pos_sidebar/scanpullsvg.svg" data-testid="menu-scan-pulls-icon" />
                <span class="li-descr" data-testid="menu-scan-pulls-label">Scan Pulls</span>
              </a>
              <a class="arrow" data-testid="menu-scan-pulls-arrow">
                <span></span>
              </a>
            </li>
          </ng-template>
          <!-- AI Chatbot -->
          <ng-template [ngxPermissionsOnly]="['ChatBot:View']">
            <li *ngIf="showChatbot" [ngClass]="{ active: isMenuItemActive[7] }" data-testid="menu-ai-chatbot">
              <a (click)="getDataForMenu(7)" class="first-a" routerLink="/production/home/chatbot"
                data-testid="menu-ai-chatbot-link">
                <img src="../../../../assets/icons/ai_bot.svg" data-testid="menu-ai-chatbot-icon" />
                <span class="li-descr" data-testid="menu-ai-chatbot-label">AI Chatbot</span>
              </a>
              <a class="arrow" data-testid="menu-ai-chatbot-arrow">
                <span></span>
              </a>
            </li>
          </ng-template>
        </ul>
      </div>
    </div>
  </div>

  <div id="content" data-testid="content">
    <app-nav-menu data-testid="nav-menu"></app-nav-menu>
    <!-- Production Screens Content-->
    <div class="w-100"
      [style.padding]="isMenuItemActive[1] || isMenuItemActive[2] ? '0' : '16px 20px 20px 20px'"
      data-testid="content-main">
      <router-outlet data-testid="router-outlet"></router-outlet>
    </div>
  </div>
</div>
